<script setup>
import {computed, defineProps, onMounted, onUnmounted, ref} from "vue";
import {couponConf} from "@/utils/config";
import axiosApi from "@/utils/axiosApi";
import {useRoute} from "vue-router";
import {EffectCards, Autoplay} from 'swiper/modules';
import SwiperCore from "swiper"
import "swiper/css"
import 'swiper/css/pagination'
import {Swiper, SwiperSlide} from "swiper/vue";
import LoginComponents from "@/components/login/LoginComponents.vue";
import XmLogin from "@/components/login/xmLogin.vue";
import store from "@/store";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import RealName from "@/components/login/RealName.vue";
import {ElMessage} from "element-plus";
import router from "@/router";

SwiperCore.use([EffectCards, Autoplay]);
const props = defineProps({
  type: {
    default: () => {
      return couponConf["hkl-scal"]
    }
  }
})
const coupon = ref({})
const showLogin = ref(false)
const route = useRoute()
const account = computed(() => store.state.account)
const getCoupon = () => {
  showLogin.value = false
  new axiosApi({
    encode: 'site',
    method: "coupon/cat_coupon_detail",
    body: {
      cid: route.params.id
    }
  }).send(res => {
    if (res.message.code === "000") {
      res.data.detail = res.data.detail.filter(v => v.key.length && v.value.length)
      coupon.value = res.data
      let details = {}
      coupon.value.detail.forEach(v => {
        if (v.key === "banner") v.value = JSON.parse(v.value)
        details[v.key] = v.value
      })
      if (!details.banner) {
        details.banner = [coupon.value.img]
      }
      coupon.value.detail = details
      // console.log(coupon)
      document.title = coupon.value.name
    }
  })
}
const paybox = ref(false)
const number = ref(1)
const order_from = computed(() => store.state.orderFrom)
onMounted(() => {
  store.dispatch("getAccounts")
  store.commit("getOrderFrom")
  getCoupon()
})
const minPrices = computed(() => {
  if (Object.keys(coupon.value).length && coupon.value.score_data[props.type.login]) {
    return parseFloat(coupon.value.score_data[props.type.login].discount)
  }
  return 0;
})
const recharge = () => {
  showLogin.value = false
  if (Object.keys(account.value).length)
    paybox.value = true
}
const maxNumber = computed(() => {
  let number = 1;
  if (Object.keys(account.value).length) {
    number = Math.floor(parseFloat(account.value.balance_miles) / minPrices.value);
  }

  return number
})
const sendSms = ref(false)
const realname = ref(false)
const loading = ref(false)
const totalPrice = computed(() => {
  return minPrices.value * number.value
})
const mobile = ref('')

const payment = () => {
  if (!/^1[2-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("请输入收货手机号");
  }
  if (!sendSms.value && props.type.login !== 'xm_air') {
    sendSms.value = true
    return
  }

  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(props.type.login === 'xm_air' ? {
    access_token: account.value.access_token,
    user_id: account.value.user_id
  } : {cust_id: account.value.cust_id})
  new axiosApi({
    method: "coupon/pay",
    encode: "site",
    body: {
      coupon_id: coupon.value.id,
      uid: account.value.uid,
      pay_type: props.type.login,
      pay_params,
      number: number.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    },
    login: props.type.login
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    if (props.type.login !== 'xm_air')
      router.replace({name: 'success', params: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => {
    loading.value = false
    ElMessage.error("兑换失败")
  })
}
onUnmounted(() => {
  paybox.value = false
})
</script>

<template>
  <el-scrollbar class="page-pid page-detail" :style="props.type.style" v-if="Object.keys(coupon).length">
    <div class="product-card">
      <h3>{{ coupon?.title }}</h3>
      <swiper loop class="product-image" autoplay>
        <swiper-slide v-for="(inx,num) in coupon?.detail?.banner" :key="num">
          <el-image :src="inx"/>
        </swiper-slide>
      </swiper>
    </div>
    <h3>详情介绍</h3>
    <div class="product-detail product-card" v-html="coupon?.remark"></div>
  </el-scrollbar>
  <div class="footer">
    <el-button type="warning" size="large" class="store" @click="router.replace({name:'store'})" round>
      点击查看门店列表
    </el-button>
    <div class="payment">
      <div class="payment-money">
        <el-text :type="props.type.login === 'xm_air' ?'primary':'danger'">
          {{ coupon.score_data?.[props.type.login]?.discount }}
        </el-text>
        {{ coupon.score_data?.[props.type.login]?.unit }}
      </div>
      <el-button :type="props.type.login === 'xm_air' ?'primary':'danger'" round
                 v-if="Object.keys(account).length > 0 && parseFloat(account.balance_miles) >= parseFloat(coupon.score_data?.[props.type.login]?.discount)"
                 @click="paybox=true">
        立即兑换
      </el-button>
      <el-button :type="props.type.login === 'xm_air' ?'primary':'danger'" round
                 v-else-if="Object.keys(account).length < 1" @click="showLogin=true">请登录
      </el-button>
      <el-button type="info" round v-else disabled>可用{{ type.login === 'xm_air' ? '积分' : '里程' }}不足</el-button>
    </div>
  </div>
  <login-components :show-login="showLogin" v-if="showLogin && type.login === 'scal'"
                    @login="recharge"/>
  <xm-login :show-login="showLogin" v-if="showLogin && type.login === 'xm_air'" @login="recharge"/>
  <el-drawer v-model="paybox" direction="btt" class="product-drawer" size="560" :show-close="false"
             :style="props.type.style">
    <template #header>
      <div class="product-title" style="align-items: center">
        <div class="product-logo" style="flex-basis: 85px;width: 80px">
          <el-image :src="coupon.img"/>
        </div>
        <div class="product-title-items">
          <h4 class="title-h">{{ coupon.title }}</h4>
          <div>
            <el-text type="info">无门槛可叠加使用</el-text>
          </div>
          <div class="product-prices">
            <!--            <el-text type="info">兑换</el-text>-->
            <el-text :type="props.type?.login==='xm_air'?'primary':'danger'" class="product-prices-values">
              {{ minPrices }}
            </el-text>
            <el-text>{{ props.type?.login === 'xm_air' ? '积分' : '里程' }}</el-text>
          </div>
        </div>
      </div>
    </template>
    <el-card class="product-card" shadow="never">
      <div class="product-card-item">
        <div class="product-card-item-title">
          <h4 class="title-h">收货手机号</h4>
        </div>
        <div class="product-card-item-values">
          <el-input placeholder="请输入收货手机号" v-model="mobile"/>
        </div>
      </div>
    </el-card>
    <el-card class="product-card" shadow="never">
      <div class="product-card-item">
        <div class="product-card-item-title">
          <h4 class="title-h">兑换数量</h4>
        </div>
        <div class="product-card-item-values">
          <el-input-number v-model="number" :min="1" :max="maxNumber"/>
        </div>
      </div>
    </el-card>
    <el-card class="product-card" shadow="never">
      <div class="product-card-item">
        <div class="product-card-item-title">
          <h4 class="title-h">可用{{ props.type.login === 'xm_air' ? '积分' : '里程' }}</h4>
        </div>
        <div class="product-card-item-values">
          {{ account.balance_miles }}
        </div>
      </div>
      <div class="product-card-item">
        <div class="product-card-item-title">
          <h4 class="title-h">支付{{ props.type.login === 'xm_air' ? '积分' : '里程' }}</h4>
        </div>
        <div class="product-card-item-values">
          {{ totalPrice }}
        </div>
      </div>
    </el-card>
    <div class="product-pay-btn">
      <el-button :type="props.type.login === 'xm_air'?'primary':'danger'" round size="large" @click="payment"
                 :loading="loading"
                 :disabled="Object.keys(account).length < 1 || account.balance_miles < totalPrice">立即兑换
      </el-button>
    </div>
  </el-drawer>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname"/>
</template>

<style scoped lang="less">
.page-detail {
  height: calc(100vh - 110px);
  background: var(--theme-color);
  box-sizing: border-box;
  padding: 10px;

  .product-card {
    background: #ffffff;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 12px;
    text-align: center;
    line-height: 1.34;
    margin-bottom: 15px;

    h3 {
      margin-bottom: 10px;
    }

    &.product-detail {
      margin-top: 15px;
      text-align: left;

      /deep/ p {
        line-height: 1.75;
      }

      /deep/ hr {
        margin: 10px 0;
      }

      /deep/ ol, ul, li {
        padding-left: 15px !important;
        line-height: 1.75;
      }
    }
  }
}

.footer {
  box-sizing: border-box;
  padding: 15px;
  height: 100px;

  .store {
    width: 100%;
  }

  .payment {
    display: flex;
    justify-content: right;
    margin-top: 10px;
    align-items: center;
  }
}

.payment-money {
  margin-right: 10px;

  .el-text {
    font-size: 1.45rem;
  }
}
</style>
